import {Customer} from '@/models/Customer'
import {CustomerAddress} from '@/models/CustomerAddress'
import {Destination} from '@/models/Destination'
import {Item} from '@/models/Item'
import {Media} from '@/models/Media'
import {Model} from '@/models/Model'
import {OrderUser} from '@/models/OrderUser'
import {Product} from '@/models/Product'
import {ProductPromotion} from '@/models/ProductPromotion'
import {Promotion} from '@/models/Promotion'
import {DataArray, DataResource, FilterSet} from '@/models/Response'
import {Stoppable} from '@/models/Stoppable'
import {Timeline} from '@/models/Timeline'
import Helper from '../services/Helper.js'


export const OrderConst = Object.freeze({
    DOC_BOOK: 'ONLI',
    STATUS_CART: 100,
    STATUS_SUBMITTED_PENDING_CONFIRM: 200,
    STATUS_SUBMITTED_PENDING_APPROVE: 300,
    STATUS_SUBMITTED_PENDING_CUSTOMER: 400,
    STATUS_APPROVED_PENDING_SYNC: 500,
    STATUS_APPROVED_PENDING_OFM: 510,
    STATUS_SYNCED_PENDING_ACTIVE: 600,
    STATUS_ACCOUNT_CONFIRMED_WAIT_DO: 700,
    STATUS_DO_CONFIRMED_WAIT_STOCK: 800,
    STATUS_STOCK_DEBITED_WAIT_START_DELIVERY: 900,
    STATUS_DELIVERY_STARTED: 910,
    STATUS_DELIVERY_SUCCESS: 950,
    STATUS_DELIVERY_FAILED: 960,
    STATUS_INVOICED: 1000,
    STATUS_PAID: 1100,
    STATUS_OVERDUE: 1200,
    STATUS_TRANSACTION_CLEAR: 1300,
    STATUS_TRANSACTION_UNCLEAR: 1400,


    STATUS_REJECT: 99,

    VAT_TYPE_SEPARATE: 0, //แยกภาษี
    VAT_TYPE_INCLUDE: 1, //รวมภาษี
    VAT_TYPE_ZERO: 2, // อัตราภาษีศูนย์
    VAT_TYPE_EXCEPT: 3, // ยกเว้นภาษี

    ITEM_FROM_NONE: '',
    ITEM_FROM_KCCP: 'K',
    ITEM_FROM_OFM: 'O',

    COMPANY_KCCP: 'K',
    COMPANY_OFM: 'O',

    COMBINE_BILL_NONE: '',
    COMBINE_BILL_TRUE: 'C',

    PRICE_GROUP_OFM: 8,

    PAY_BY_MONEY: 'money',
    PAY_BY_POINT: 'point',

    map(status: number): string {
        switch (status) {
            case OrderConst.STATUS_CART:
                return 'ตะกร้า'
            case OrderConst.STATUS_SUBMITTED_PENDING_CONFIRM:
                return 'รอยืนยัน'
            case OrderConst.STATUS_SUBMITTED_PENDING_APPROVE:
                return 'รออนุมัติ'
            case OrderConst.STATUS_SUBMITTED_PENDING_CUSTOMER:
                return 'รออนุมัติลูกค้า'
            case OrderConst.STATUS_APPROVED_PENDING_SYNC:
                return 'ส่งเข้า ERP'
            case OrderConst.STATUS_APPROVED_PENDING_OFM:
                return 'ส่งเข้า OFM'
            case OrderConst.STATUS_SYNCED_PENDING_ACTIVE:
                return 'รอบัญชีอนุมัติ'
            case OrderConst.STATUS_ACCOUNT_CONFIRMED_WAIT_DO:
                return 'รอจัดทริป'
            case OrderConst.STATUS_DO_CONFIRMED_WAIT_STOCK:
                return 'รอคลังอนุมัติ'
            case OrderConst.STATUS_STOCK_DEBITED_WAIT_START_DELIVERY:
                return 'รอขนขึ้นรถ'
            case OrderConst.STATUS_DELIVERY_STARTED:
                return 'กำลังเดินทาง'
            case OrderConst.STATUS_DELIVERY_SUCCESS:
                return 'ส่งสำเร็จ'
            case OrderConst.STATUS_DELIVERY_FAILED:
                return 'ส่งไม่สำเร็จ'
            case OrderConst.STATUS_INVOICED:
                return 'แจ้งหนี้'
            case OrderConst.STATUS_PAID:
                return 'จ่ายแล้ว'
            case OrderConst.STATUS_REJECT:
                return 'ยกเลิก'
            //รอจัดทริป
            //กำลังขนส่ง
            //
        }
        // debugger
        return 'ไม่ระบุ[' + status + ']'
    },

    mapShort(status: number): string {
        switch (status) {
            case OrderConst.STATUS_CART:
                return 'ตะกร้า'
            case OrderConst.STATUS_SUBMITTED_PENDING_CONFIRM:
                return 'รอยืนยัน'
            case OrderConst.STATUS_SUBMITTED_PENDING_APPROVE:
                return 'รออนุมัติ'
            case OrderConst.STATUS_SUBMITTED_PENDING_CUSTOMER:
                return 'รออนุมัติลูกค้า'
            case OrderConst.STATUS_APPROVED_PENDING_SYNC:
                return 'ส่งเข้า ERP'
            case OrderConst.STATUS_APPROVED_PENDING_OFM:
                return 'ส่งเข้า OFM'
            case OrderConst.STATUS_SYNCED_PENDING_ACTIVE:
                return 'รอบัญชี'
            case OrderConst.STATUS_ACCOUNT_CONFIRMED_WAIT_DO:
                return 'รอทริป'
            case OrderConst.STATUS_DO_CONFIRMED_WAIT_STOCK:
                return 'รอคลัง'
            case OrderConst.STATUS_STOCK_DEBITED_WAIT_START_DELIVERY:
                return 'รอขึ้น'
            case OrderConst.STATUS_DELIVERY_STARTED:
                return 'เดินทาง'
            case OrderConst.STATUS_DELIVERY_SUCCESS:
                return 'ส่งแล้ว'
            case OrderConst.STATUS_DELIVERY_FAILED:
                return 'ส่งไม่ได้'
            case OrderConst.STATUS_INVOICED:
                return 'หนี้'
            case OrderConst.STATUS_PAID:
                return 'จ่าย'
            case OrderConst.STATUS_REJECT:
                return 'ยกเลิก'
            //รอจัดทริป
            //กำลังขนส่ง
            //
        }
        // debugger
        return 'ไม่ระบุ[' + status + ']'
    },

    do_map(status: string): string {
        switch (status) {
            case 'success':
                return 'ส่งสำเร็จ'
            case 'failed':
                return 'ส่งไม่สำเร็จ'
        }
        return status
    },
    do_color(status: string): string {
        switch (status) {
            case 'success':
                return 'green lighten-2'
            case 'failed':
                return 'red lighten-2'
        }
        return ''
    },
    color(status: number | null): string {
        switch (parseInt(`${status}`)) {
            case OrderConst.STATUS_CART:
                return 'grey lighten-1'
            case OrderConst.STATUS_SUBMITTED_PENDING_CONFIRM:
                return 'red'
            case OrderConst.STATUS_SUBMITTED_PENDING_APPROVE:
                return 'grey lighten-1'
            case OrderConst.STATUS_SUBMITTED_PENDING_CUSTOMER:
                return 'grey lighten-1'
            case OrderConst.STATUS_APPROVED_PENDING_SYNC:
                return 'grey lighten-1'
            case OrderConst.STATUS_APPROVED_PENDING_OFM:
                return 'grey lighten-1'
            case OrderConst.STATUS_SYNCED_PENDING_ACTIVE:
                return 'teal'
            case OrderConst.STATUS_ACCOUNT_CONFIRMED_WAIT_DO:
                return 'amber'
            case OrderConst.STATUS_DO_CONFIRMED_WAIT_STOCK:
                return 'lime'
            case OrderConst.STATUS_STOCK_DEBITED_WAIT_START_DELIVERY:
                return 'light-green'
            case OrderConst.STATUS_DELIVERY_STARTED:
                return 'light-green'
            case OrderConst.STATUS_DELIVERY_SUCCESS:
                return 'light-green'
            case OrderConst.STATUS_DELIVERY_FAILED:
                return 'light-red'
            case OrderConst.STATUS_INVOICED:
                return 'green'
            case OrderConst.STATUS_PAID:
                return 'blue-grey'
            case OrderConst.STATUS_REJECT:
                return 'red'
        }
        // debugger
        return ''
    },
    alt(status: number): string {
        switch (parseInt(`${status}`)) {
            case OrderConst.STATUS_CART:
                return 'ตะกร้า'
            case OrderConst.STATUS_SUBMITTED_PENDING_CONFIRM:
                return 'รอยืนยัน'
            case OrderConst.STATUS_SUBMITTED_PENDING_APPROVE:
                return 'รออนุมัติ'
            case OrderConst.STATUS_SUBMITTED_PENDING_CUSTOMER:
                return 'รออนุมัติลูกค้า'
            case OrderConst.STATUS_APPROVED_PENDING_SYNC:
                return 'ส่งเข้า ERP'
            case OrderConst.STATUS_APPROVED_PENDING_OFM:
                return 'ส่งเข้า OFM'
            case OrderConst.STATUS_SYNCED_PENDING_ACTIVE:
                return 'รอบัญชี'
            case OrderConst.STATUS_ACCOUNT_CONFIRMED_WAIT_DO:
                return 'รอจัดทริป'
            case OrderConst.STATUS_DO_CONFIRMED_WAIT_STOCK:
                return 'รอคลังตัด stock'
            case OrderConst.STATUS_STOCK_DEBITED_WAIT_START_DELIVERY:
                return 'ตัด stock ครบแล้ว'
            case OrderConst.STATUS_DELIVERY_STARTED:
                return 'กำลังเดินทาง'
            case OrderConst.STATUS_DELIVERY_SUCCESS:
                return 'ส่งแล้ว'
            case OrderConst.STATUS_DELIVERY_FAILED:
                return 'ส่งไม่ได้'
            case OrderConst.STATUS_INVOICED:
                return 'ออก invoice ครบ หรือ ปิดออเดอร์แล้ว'
            case OrderConst.STATUS_PAID:
                return 'จ่ายครบแล้ว'
            case OrderConst.STATUS_REJECT:
                return 'ยกเลิก'
            //รอจัดทริป
            //กำลังขนส่ง
            //
        }
        // debugger
        return 'ไม่ระบุ[' + status + ']'
    }
})


export class Order extends Model implements Stoppable {


    declare id: number
    created_at: Date | null
    updated_at: Date | null
    customer_id: number
    customer_code: string | null
    doc_book: string | null
    code: string | null
    item_from: string | null
    company: string | null
    combine_bill: boolean | null
    eta: Date | null
    comment: string | null
    total_external_discount: number | null
    total_commission_able: number | null
    total_commission_amount: number | null
    total_gross: number | null
    total_vat: number | null
    total_net: number | null
    price_group: number | null
    status: number | null
    status_commission: number | null
    status_shipping: number | null
    status_payment: number | null
    status_discount_claim: number | null
    status_discount_payment: number | null
    customer: Customer | null
    mode: string | null
    items: Item[]
    dynamicPromotionItems: Item[]
    sales: OrderUser[]
    stock_wh: string | null
    erp_so_at: Date | string | null

    invoice_code: string | null
    invoice_date: Date | string | null
    do_code: string | null
    do_date: Date | string | null
    do_status: string | null
    do_payment: string | null
    do_comment: string | null
    do_driver_id: number | null
    do_delivered_at: Date | string | null
    billing_code: string | null

    receipt_code: string | null
    receipt_date: Date | string | null


    primary_sale: string | null

    vat_type: number | null
    credit_term: number | null
    vat_percent: number | null
    date_delivery: Date | string | null
    submitted_at: Date | string | null

    time_table: any | null

    commission_option: number | null
    tmp_com_option: number | null


    cache_do_qty: number | null
    cache_s_qty: number | null
    cache_f_qty: number | null
    cache_inv_qty: number | null

    timeline: Timeline[]

    volume: number | null
    weight: number | null

    shipping_address: CustomerAddress | null
    shipping_address_id: number | null
    ship_method: string | null
    project: string | null
    project_cb3: boolean | null
    override_discounts: Object | null
    pay_by: string | null
    total_point: number | null

    destination: Destination | null

    custom: {
        check: {
            CB3: {},
            minimum: {},
            credit: {},
            price: { last_price: number, price: number }[],
            price2: { last_price: number, price: number }[],
            invoices: { code: string, status: number, total_net: number, invoice_code: string, invoice_date: string }[]
        },
        authorize: {
            CB3: { user: number[] },
            minimum: { user: number[] },
            credit: { user: number[] },
            price: { user: number[] },
            price2: { user: number[] },
            invoices: { user: number[] }
        },
        approving: {
            CB3: { flag: boolean, at: Date, by: string },
            minimum: { flag: boolean, at: Date, by: string },
            credit: { flag: boolean, at: Date, by: string },
            price: { flag: boolean, at: Date, by: string },
            price2: { flag: boolean, at: Date, by: string },
            invoices: { flag: boolean, at: Date, by: string }
        }
    } | null

    medias: Media[]

    getSkipField(): string[] {
        return ['timeline']
    }

    getResourceURL(): string {
        return Helper.setting.order.getResourceAPI
    }

    async QuotationCart(): Promise<Order> {
        // debugger
        return await this.SetStatus(OrderConst.STATUS_CART)
    }

    async SubmitCart(): Promise<Order> {
        // debugger
        return await this.SetStatus(OrderConst.STATUS_SUBMITTED_PENDING_APPROVE)
    }

    async ReCartOrder(): Promise<Order> {
        // debugger
        return await this.SetStatus(OrderConst.STATUS_CART)
    }


    async SetStatus(status: number): Promise<Order> {
        // debugger
        this.status = status
        return await this.save<Order>()
    }

    async SetAddress(address_id: number): Promise<Order> {
        // debugger
        this.shipping_address_id = address_id
        return await this.save<Order>()
    }


    async SetComOption(com_option: number): Promise<Order> {
        // debugger
        this.commission_option = com_option
        return await this.save<Order>()
    }

    async SetTmpComOption(com_option: number): Promise<Order> {
        // debugger
        this.tmp_com_option = com_option
        return await this.save<Order>()
    }


    static cart_on_change_price_group(cart: Order) {
        cart.items = cart.items.filter(item => item.quantity !== null && item.quantity > 0)
        const price_group = cart.price_group
        for (let i in cart.items) {
            const item = cart.items[i]
            if (item.product) {
                switch (price_group) {
                    case 8:
                        if (item.product.price_8) {
                            item.price_init = item.price_final = item.price_in_vat = item.product.price_8
                        }
                        break
                    case 9:
                        if (item.product.price_9) {
                            item.price_init = item.price_final = item.price_in_vat = item.product.price_9
                        }
                        break
                    case 10:
                        if (item.product.price_10) {
                            item.price_init = item.price_final = item.price_in_vat = item.product.price_10
                        }
                        break
                }

            }
        }
        Order.cart_validate(cart)
    }

    static cart_validate(cart: Order, dynamicPromotions: Promotion[] = []) {
        // console.log('cart_validate', cart)
        if (!cart.stock_wh && cart.customer) {
            cart.stock_wh = cart.customer.type == 'MT' ? 'MT' : 'PJ'
        }

        cart.override_discounts = {}
        cart.item_from = OrderConst.ITEM_FROM_NONE

        let item_map = {}
        let promotion_map = {}

        const vat_percent = cart.vat_percent ? cart.vat_percent : 0
        let total_net = 0
        let total_point = 0
        let total_ex_discount = 0
        cart.items = cart.items.filter(item => item.quantity !== null && item.quantity > 0)
        let itemToCalDynamicPromotion = {}
        for (let i in cart.items) {
            const item = cart.items[i]
            if (cart.item_from == OrderConst.ITEM_FROM_NONE) {
                if (item.product?.type_code == 'TRAD_OFM') {
                    cart.item_from = OrderConst.ITEM_FROM_OFM
                } else {
                    cart.item_from = OrderConst.ITEM_FROM_KCCP
                }
            }

            item.index_no = parseInt(i) + 1
            if (item.discount_internal_amount == null) {
                item.discount_internal_amount = 0
            }

            if (item.discount_external_amount == null) {
                item.discount_external_amount = 0
            }

            let price_at_bill = item.price_in_vat
            item.price_final = item.price_in_vat
            if (item.quantity !== null) {
                price_at_bill -= item.discount_internal_amount / item.quantity
                item.price_final -= item.discount_internal_amount / item.quantity
            }

            if (item.quantity !== null) {
                item.price_final -= (item.discount_external_amount / item.quantity) * (1.00 + vat_percent / 100)
            }
            item.price_final = Math.round(item.price_final * 100) / 100

            if (price_at_bill !== null && item.quantity !== null) {
                item.total_net = item.quantity * price_at_bill
                item.total_gross = Math.round(item.total_net / (1.00 + vat_percent / 100) * 100) / 100
                item.total_vat = item.total_net - item.total_gross
                total_net += item.total_net
            }
            if (item.point_final !== null && item.quantity !== null) {
                total_point += item.quantity * item.point_final
            }

            if (item.discount_external_amount != null && item.quantity != null && item.quantity != 0) {
                total_ex_discount += item.discount_external_amount
                item.discount_external_percent = Math.round(item.discount_external_amount / (item.price_ex_vat * item.quantity) * 100 * 100) / 100
            }


            if (item.promotion_id && [null, 'S'].includes(item.promotion_type)) {
                if (promotion_map[item.promotion_id] == null) {
                    promotion_map[item.promotion_id] = []
                    item.is_start_of_promotion = true
                    item.promotion_pack = []
                } else {
                    promotion_map[item.promotion_id][0].promotion_pack.push(item)
                    item.is_start_of_promotion = false
                }
                promotion_map[item.promotion_id].push(item)
            } else {
                item_map[item.product_id] = item
                item.is_start_of_promotion = null

                if (item.price_init == item.price_in_vat && item.discount_internal_amount == 0 && item.discount_external_amount == 0) {
                    itemToCalDynamicPromotion[item.product_id] =
                        {
                            'price': price_at_bill,
                            'quantity': (itemToCalDynamicPromotion[item.product_id] ? itemToCalDynamicPromotion[item.product_id].quantity : 0) + item.quantity
                        }
                } else {
                    console.log('Skip cal dynamic', [item.product?.name, item.price_init, item.price_in_vat, item.discount_internal_amount, item.discount_external_amount])
                }
            }
        }


        let price_group = cart.customer?.price_group
        if (cart.item_from == OrderConst.ITEM_FROM_OFM) {
            price_group = cart.price_group
            if (price_group == OrderConst.PRICE_GROUP_OFM) {
                cart.company = OrderConst.COMPANY_OFM
            } else {
                cart.company = OrderConst.COMPANY_KCCP
            }
        } else {
            cart.company = OrderConst.COMPANY_KCCP
            if (price_group)
                cart.price_group = price_group.price_group
        }

        const promotionsToCal = dynamicPromotions
            .filter(p => p.price_group == price_group.price_group)
            .sort((a, b) => b.total_price - a.total_price)

        let oldDynamicPromotionItems: number[] = []
        if (cart.dynamicPromotionItems) {
            oldDynamicPromotionItems = cart.dynamicPromotionItems.map(promotionItem => {
                return promotionItem.product_id
            })
        }
        console.log('oldDynamicPromotionItems', oldDynamicPromotionItems)

        cart.dynamicPromotionItems = []
// debugger
        // debugger
        // dynamicItem
        let stillMatch = true
        let total_promotion_discount = 0
        // console.log('itemToCalDynamicPromotion', itemToCalDynamicPromotion)
        while (stillMatch) {
            stillMatch = false
            for (let i = 0; i < promotionsToCal.length; i++) {
                let itemIterate = JSON.parse(JSON.stringify(itemToCalDynamicPromotion))
                const promotion = promotionsToCal[i]
                // console.log('promotion', promotion.name)
                // console.log('promotion', promotion)
                let totalAmountToMatch = -1
                let countValid = -1
                let j = 0
                let productPromoToCheck = promotion.product_promotions.filter(p => ['D', 'T'].includes(p.promotion_type))

                while ((countValid != 0) && j < productPromoToCheck.length) {
                    const itemToCheck = productPromoToCheck[j]
                    if (!itemToCheck || !itemToCheck.product_id || !itemToCheck.quantity) continue
                    if (countValid === -1) {
                        countValid = itemToCheck.quantity
                        totalAmountToMatch = itemToCheck.quantity
                    }
                    if (itemIterate[itemToCheck.product_id] && itemIterate[itemToCheck.product_id].quantity > 0) {
                        //Has product to check
                        itemIterate[itemToCheck.product_id].quantity -= 1
                        countValid--
                        j = 0
                    } else {
                        j++
                    }
                }

                console.log('----iterate----')
                //Check item valid for promotion
                if (countValid == 0) {
                    // debugger
                    if (promotion.discount_percent && promotion.discount_percent > 0) {
                        let totalAmountToDiscount = totalAmountToMatch
                        let discountItem = new Item()
                        discountItem.product_id = 1

                        let discountProduct = new Product()
                        discountProduct.nickname = 'ส่วนลดโปรโมชั่น ' + promotion.discount_percent + '%'
                        discountItem.product = discountProduct
                        discountItem.promotion = promotion
                        discountItem.promotion_id = promotion.id
                        discountItem.promotion_qty = 1
                        discountItem.is_start_of_promotion = true
                        discountItem.promotion_type = promotion.promotion_type


                        //Remove all product that match
                        let productPromoToCheck = promotion.product_promotions.filter(p => ['D', 'T'].includes(p.promotion_type))
                        for (let k = 0; k < productPromoToCheck.length; k++) {
                            const itemToCheck = productPromoToCheck[k]
                            if (itemIterate[itemToCheck.product_id] && itemIterate[itemToCheck.product_id].quantity > 0) {
                                totalAmountToDiscount += itemIterate[itemToCheck.product_id].quantity
                                itemIterate[itemToCheck.product_id].quantity = 0
                            }
                        }

                        cart.dynamicPromotionItems.push(discountItem)

                        discountItem.quantity = totalAmountToDiscount
                        discountItem.total_net = -(promotion.total_price / totalAmountToMatch) * totalAmountToDiscount
                        total_promotion_discount += discountItem.total_net
                    }

                    //Discount per product
                    let totalAmountToDiscount = 0


                    // --- Remove all product that match ---
                    let productPromoToCheck = promotion.product_promotions.filter(p => ['D', 'T'].includes(p.promotion_type))
                    let itemIterateMatchedPrice = JSON.parse(JSON.stringify(itemToCalDynamicPromotion))
                    for (let k = 0; k < productPromoToCheck.length; k++) {
                        const itemToCheck = productPromoToCheck[k]
                        if (itemToCheck.display_price > 0 && itemIterateMatchedPrice[itemToCheck.product_id] && itemIterateMatchedPrice[itemToCheck.product_id].quantity > 0) {
                            if (!cart.override_discounts.hasOwnProperty(itemToCheck.product_id)) {
                                console.log('Found override discount', itemToCheck)

                                cart.override_discounts[itemToCheck.product_id] = {
                                    promotion_id: promotion.id,
                                    price: itemToCheck.display_price
                                }
                            }
                        }
                    }
                    //console.log("productPromoToCheck",productPromoToCheck)
                    // --- /Remove all product that match ---


                    const allFreeItemsIncludeChild = promotion.product_promotions.filter(p => p.promotion_type == 'F')

                    if (allFreeItemsIncludeChild[0]) {

                        let freeItems: ProductPromotion[] = []
                        let lastParent = freeItems[0]

                        for (let i = 0; i < allFreeItemsIncludeChild.length; i++) {
                            const fi = allFreeItemsIncludeChild[i]
                            if (fi.is_child) {
                                lastParent.children.push(fi)
                            } else {
                                fi.children = []
                                freeItems.push(fi)
                                lastParent = fi
                            }
                        }

                        // const freeItems = promotion.product_promotions.filter(p => p.promotion_type == 'F' && !p.is_child)
                        let freeItem = freeItems[0]
                        const availableFreeItems = freeItems.map(promotionItem => {
                            return promotionItem.product_id
                        })


                        let dynamicItem = new Item()


                        //Search for product from old state
                        for (let i = 0; i < oldDynamicPromotionItems.length; i++) {
                            const preferProd = oldDynamicPromotionItems[i]
                            if (availableFreeItems.includes(preferProd)) {
                                freeItem = freeItems.filter(p => p.product_id == preferProd)[0]
                                console.log('prefer reduce', preferProd)
                                console.log('prefer reduce', freeItem.product?.name)
                                oldDynamicPromotionItems.splice(oldDynamicPromotionItems.indexOf(preferProd), 1)
                                console.log('oldDynamicPromotionItems reduce', oldDynamicPromotionItems)
                                break
                            }
                        }


                        dynamicItem.product_id = freeItem.product_id
                        dynamicItem.product = freeItem.product
                        dynamicItem.quantity = freeItem.quantity
                        dynamicItem.total_net = freeItem.display_price * freeItem.quantity
                        dynamicItem.promotion = promotion
                        dynamicItem.promotion_id = promotion.id
                        dynamicItem.promotion_qty = dynamicItem.quantity
                        dynamicItem.is_start_of_promotion = true
                        dynamicItem.promotion_type = freeItem.promotion_type
                        if (freeItem.product)
                            dynamicItem.unit = freeItem.product.unit_primitive

                        cart.dynamicPromotionItems.push(dynamicItem)
                        //Add child item
                        for (let i = 0; i < freeItem.children.length; i++) {
                            const childItem = freeItem.children[i]
                            let childCartItem = new Item()
                            childCartItem.product_id = childItem.product_id
                            childCartItem.product = childItem.product
                            childCartItem.quantity = childItem.quantity
                            childCartItem.total_net = childItem.display_price * childItem.quantity
                            childCartItem.promotion = promotion
                            childCartItem.promotion_id = promotion.id
                            childCartItem.promotion_qty = dynamicItem.quantity
                            childCartItem.is_start_of_promotion = false
                            childCartItem.promotion_type = childItem.promotion_type
                            if (childItem.product)
                                childCartItem.unit = childItem.product.unit_primitive

                            cart.dynamicPromotionItems.push(childCartItem)
                        }
                    }
                    itemToCalDynamicPromotion = JSON.parse(JSON.stringify(itemIterate))
                    stillMatch = true
                    //Break to recal from first promotion again
                    console.log('match', [promotion, itemIterate])
                    break
                } else {
                    // console.log('not match', itemIterate)
                }

            }
        }


        const recalItem = cart.items.filter(item => item.quantity !== null && item.quantity > 0 && !item.is_start_of_promotion)

        for (let i in cart.items) {
            const item = cart.items[i]
            if (cart.override_discounts.hasOwnProperty(item.product_id) && item.quantity) {
                total_promotion_discount += (cart.override_discounts[item.product_id]['price'] - item.price_in_vat) * item.quantity
                // console.log('cart.override_discounts[item.product_id]',cart.override_discounts[item.product_id])
                // console.log('item.price_in_vat',item.price_in_vat)
                // item.total_net = item.quantity * price_at_bill
                // item.total_gross = Math.round(item.total_net / (1.00 + vat_percent / 100) * 100) / 100
                // item.total_vat = item.total_net - item.total_gross

            }
        }

        total_net += total_promotion_discount

        cart.total_external_discount = total_ex_discount

        cart.total_net = total_net
        cart.total_gross = Math.round(cart.total_net / (1.00 + vat_percent / 100) * 100) / 100
        cart.total_vat = cart.total_net - cart.total_gross

        cart.total_point = total_point

        console.log('cart_validate', cart)
        return {
            item_map: item_map,
            promotion_map: promotion_map
        }
    }
}

export class DataOrder extends DataResource {

    declare data: Order

}


export class DataOrdersArray extends DataArray {

    declare data: Order[]
    filter: FilterOrder = new FilterOrder()
}


export class FilterOrder {

    status: FilterSet = new FilterSet()
}
